import React from 'react';

const LogoBlack = () => {
  return (
    <svg width="205.624" height="87.564" viewBox="0 0 205.624 87.564">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_1"
            width="205.624"
            height="87.564"
            transform="translate(0 0)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Group_1" clipPath="url(#clip-path)">
        <path
          id="Path_1"
          d="M87.564,43.78a43.782,43.782,0,1,0-76.223,29.4H76.223a43.622,43.622,0,0,0,11.341-29.4"
          transform="translate(0 0.002)"
          fill="#fff"
          opacity="0.2"
        />
        <path
          id="Path_2"
          d="M198.913,864.879H134.032q.562.62,1.148,1.218l.012.012q.184.188.371.374l.065.064q.161.16.323.318l.091.088q.15.145.3.289l.107.1.291.272.118.108.285.26.125.112.284.252.128.112.286.247.13.112.29.244.129.108.3.245.125.1.31.248.117.093.33.257.1.078q.182.14.366.278l.069.052q.885.664,1.8,1.284l.075.05q.189.127.379.252l.117.076.342.221.14.088.323.2.153.095.314.191.162.1.309.183.169.1.307.177.173.1.308.172.175.1.311.168.174.093.317.166.171.089.328.167.163.082.347.171.147.072.382.182.115.055q.237.111.475.219l.025.012q.509.231,1.025.448l.1.044.4.168.158.063.355.141.184.071.332.127.2.074.321.118.207.074.315.112.215.074.311.106.219.073.31.1.222.071.311.1.223.068.314.093.222.065.319.09.22.061.328.088.214.056.343.087.2.05.376.09.171.04q.242.056.485.109l.064.014q.277.06.556.117l.123.024.431.085.2.036.36.066.223.038.336.057.236.038.325.051.245.036.318.045.25.033.316.041.254.031.315.036.256.028.315.032.257.025.316.028.258.021.32.024.256.018.325.02.253.014.334.016.245.011.35.012.231.007.388.008.194,0q.292,0,.585,0t.584,0l.194,0,.388-.008.231-.007.35-.012.245-.011.334-.016.253-.014.325-.02.256-.018.32-.024.258-.021.316-.028.258-.025.315-.032.256-.028.315-.036.254-.031.316-.041.25-.033.318-.045.245-.036.325-.051.236-.038.336-.057.223-.038.36-.066.2-.036.431-.085.123-.024q.278-.057.556-.117l.064-.014q.243-.053.485-.109l.171-.04.376-.09.2-.05.343-.087.214-.056.328-.088.22-.061.319-.09.222-.065.314-.093.223-.068.311-.1.222-.071.31-.1.219-.073.311-.106.215-.074.315-.112.207-.074.321-.118.2-.074.332-.127.184-.071.355-.141.158-.063.4-.168.1-.044q.516-.218,1.025-.448l.025-.012q.238-.108.475-.219l.115-.055.382-.182.147-.072.347-.171.163-.082.328-.167.171-.089.317-.166.174-.093.311-.168.175-.1.307-.172.173-.1.307-.177.169-.1.309-.183.162-.1.314-.191.153-.095.323-.2.14-.088.342-.221.117-.076q.19-.125.379-.252l.075-.05q.919-.619,1.8-1.284l.069-.052q.184-.138.366-.278l.1-.078.33-.257.117-.093.31-.248.125-.1.3-.245.129-.108.29-.244.13-.112.285-.247.128-.112.284-.252.125-.112.285-.26.118-.108.291-.272.107-.1q.152-.144.3-.289l.091-.088q.162-.158.323-.318l.065-.064q.187-.186.371-.374l.012-.012q.585-.6,1.148-1.218"
          transform="translate(-122.69 -791.695)"
          fill="#fff"
        />
        <path
          id="Path_3"
          d="M1233.608,105.891h2.207V104.9c0-3.8,2.411-5.809,5.228-5.809a4.537,4.537,0,0,1,4.414,2.381l-2.672,1.859a2.558,2.558,0,0,0-2.033-1.307c-.842,0-1.452.581-1.452,1.859a7.423,7.423,0,0,0,.29,2h3.224v3.049h-3.049v9.613h-3.95V108.94h-2.207Z"
          transform="translate(-1129.223 -90.71)"
          fill="#fff"
        />
        <path
          id="Path_4"
          d="M1363.339,106.851a2.28,2.28,0,1,1,2.294,2.265,2.239,2.239,0,0,1-2.294-2.265m.29,4.066h1.365a9.314,9.314,0,0,0,2.614-.232V123.58h-3.979Z"
          transform="translate(-1247.976 -95.736)"
          fill="#fff"
        />
        <path
          id="Path_5"
          d="M1437.816,105.891h2.207V104.9c0-3.8,2.411-5.809,5.228-5.809a4.537,4.537,0,0,1,4.414,2.381l-2.672,1.859a2.558,2.558,0,0,0-2.033-1.307c-.842,0-1.452.581-1.452,1.859a7.428,7.428,0,0,0,.29,2h3.224v3.049h-3.05v9.613h-3.95V108.94h-2.207Z"
          transform="translate(-1316.151 -90.71)"
          fill="#fff"
        />
        <path
          id="Path_6"
          d="M1569.894,132.452l1.167-.073.519-.021a8.463,8.463,0,0,0,2.259-.241l.039,4h4.618v3.049h-4.618v5.344c0,1.075.494,1.626,1.22,1.626s1.394-.668,1.8-1.568l2.7,1.684a5.125,5.125,0,0,1-9.7-2.352v-4.734"
          transform="translate(-1437.053 -120.938)"
          fill="#fff"
        />
        <path
          id="Path_7"
          d="M1691.79,182.627a6.83,6.83,0,0,1,6.68-6.651c3.543,0,6.36,2.9,6.36,7.261H1695.8a3.164,3.164,0,0,0,3.369,3.02,2.841,2.841,0,0,0,2.875-1.684l2.73,1.51c-.958,1.888-2.875,3.137-5.808,3.137-4.124,0-7.173-2.933-7.173-6.593m4.008-1.452h5.053a2.489,2.489,0,0,0-2.439-2.585,2.674,2.674,0,0,0-2.614,2.585"
          transform="translate(-1548.634 -161.085)"
          fill="#fff"
        />
        <path
          id="Path_8"
          d="M1867.854,182.627a6.83,6.83,0,0,1,6.68-6.651c3.543,0,6.36,2.9,6.36,7.261h-9.032a3.163,3.163,0,0,0,3.369,3.02,2.841,2.841,0,0,0,2.875-1.684l2.73,1.51c-.958,1.888-2.875,3.137-5.808,3.137-4.124,0-7.174-2.933-7.174-6.593m4.008-1.452h5.053a2.489,2.489,0,0,0-2.439-2.585,2.674,2.674,0,0,0-2.614,2.585"
          transform="translate(-1709.8 -161.085)"
          fill="#fff"
        />
        <path
          id="Path_9"
          d="M2054.9,176.266h1.365a8.094,8.094,0,0,0,2.614-.232v2.323a4.969,4.969,0,0,1,4.531-2.381c2.672,0,4.356,1.539,4.356,4.618v8.335h-3.95v-7.464c0-1.568-.639-2.12-1.859-2.12-1.859,0-3.079,1.278-3.079,3.485v6.1H2054.9Z"
          transform="translate(-1881.018 -161.085)"
          fill="#fff"
        />
        <path
          id="Path_10"
          d="M1253.515,441.849h1.365a8.2,8.2,0,0,0,2.614-.232v2.5a4.374,4.374,0,0,1,3.979-2.556c3.195,0,6.1,2.991,6.1,6.622s-2.9,6.622-6.1,6.622a4.406,4.406,0,0,1-3.979-2.556v8.364h-3.979Zm9.962,6.331a3.147,3.147,0,0,0-3.078-3.34,3.357,3.357,0,0,0,0,6.68,3.13,3.13,0,0,0,3.078-3.34"
          transform="translate(-1147.445 -404.195)"
          fill="#fff"
        />
        <path
          id="Path_11"
          d="M1441.591,448.209a6.83,6.83,0,0,1,6.68-6.651c3.543,0,6.36,2.9,6.36,7.261H1445.6a3.164,3.164,0,0,0,3.369,3.02,2.841,2.841,0,0,0,2.875-1.684l2.73,1.51c-.958,1.888-2.875,3.137-5.809,3.137-4.124,0-7.173-2.933-7.173-6.593m4.008-1.452h5.053a2.489,2.489,0,0,0-2.439-2.585,2.674,2.674,0,0,0-2.614,2.585"
          transform="translate(-1319.607 -404.194)"
          fill="#fff"
        />
        <path
          id="Path_12"
          d="M1628.637,441.848H1630a8.2,8.2,0,0,0,2.614-.232v2.527a3.664,3.664,0,0,1,3.543-2.585,3.522,3.522,0,0,1,3.369,2.294l-2.73,2.352c-.523-.9-1.017-1.249-1.8-1.249-1.365,0-2.381,1.191-2.381,3.195v6.36h-3.979Z"
          transform="translate(-1490.825 -404.194)"
          fill="#fff"
        />
        <path
          id="Path_13"
          d="M1761.8,448.209c0-3.543,3.224-6.651,7.319-6.651a6,6,0,0,1,5.344,2.846l-2.7,2.207a3.369,3.369,0,0,0-2.875-1.888c-1.714,0-2.962,1.423-2.962,3.514,0,2.062,1.162,3.427,3.166,3.427a2.981,2.981,0,0,0,2.962-1.772l2.614,1.772a6.2,6.2,0,0,1-5.721,3.137,6.871,6.871,0,0,1-7.144-6.593"
          transform="translate(-1612.724 -404.194)"
          fill="#fff"
        />
        <path
          id="Path_14"
          d="M1927.576,448.209a6.83,6.83,0,0,1,6.68-6.651c3.543,0,6.36,2.9,6.36,7.261h-9.032a3.164,3.164,0,0,0,3.369,3.02,2.841,2.841,0,0,0,2.875-1.684l2.73,1.51c-.958,1.888-2.875,3.137-5.809,3.137-4.124,0-7.173-2.933-7.173-6.593m4.008-1.452h5.053a2.489,2.489,0,0,0-2.44-2.585,2.674,2.674,0,0,0-2.614,2.585"
          transform="translate(-1764.469 -404.194)"
          fill="#fff"
        />
        <path
          id="Path_15"
          d="M2114.622,441.848h1.365a8.094,8.094,0,0,0,2.614-.232v2.323a4.969,4.969,0,0,1,4.531-2.381c2.672,0,4.356,1.539,4.356,4.618v8.335h-3.95v-7.464c0-1.568-.639-2.12-1.859-2.12-1.859,0-3.079,1.278-3.079,3.485v6.1h-3.979Z"
          transform="translate(-1935.687 -404.194)"
          fill="#fff"
        />
        <path
          id="Path_16"
          d="M2292.151,407.532V402.8H2290v-2.614l.2-.029a3.325,3.325,0,0,0,3.136-3.6V395.8h.174a9.313,9.313,0,0,0,2.614-.232v4.182h4.618V402.8h-4.618v5.344c0,1.074.494,1.626,1.22,1.626s1.394-.668,1.8-1.568l2.7,1.684a5.125,5.125,0,0,1-9.7-2.352"
          transform="translate(-2096.227 -362.095)"
          fill="#fff"
        />
        <path
          id="Path_17"
          d="M1253.515,707.431h1.365a8.2,8.2,0,0,0,2.614-.232v2.5a4.374,4.374,0,0,1,3.979-2.556c3.195,0,6.1,2.991,6.1,6.622s-2.9,6.622-6.1,6.622a4.406,4.406,0,0,1-3.979-2.556v8.364h-3.979Zm9.962,6.331a3.147,3.147,0,0,0-3.078-3.34,3.357,3.357,0,0,0,0,6.68,3.13,3.13,0,0,0,3.078-3.34"
          transform="translate(-1147.445 -647.304)"
          fill="#fff"
        />
        <path
          id="Path_18"
          d="M1452.574,631.177h1.365a9.17,9.17,0,0,0,2.614-.232v19.4h-3.979Z"
          transform="translate(-1329.66 -577.556)"
          fill="#fff"
        />
        <path
          id="Path_19"
          d="M1530.831,713.791a6.83,6.83,0,0,1,6.68-6.651c3.543,0,6.36,2.9,6.36,7.261h-9.032a3.164,3.164,0,0,0,3.369,3.02,2.841,2.841,0,0,0,2.875-1.684l2.73,1.51c-.958,1.888-2.875,3.137-5.808,3.137-4.124,0-7.173-2.933-7.173-6.593m4.008-1.452h5.053a2.489,2.489,0,0,0-2.439-2.585,2.674,2.674,0,0,0-2.614,2.585"
          transform="translate(-1401.295 -647.303)"
          fill="#fff"
        />
        <path
          id="Path_20"
          d="M1706.894,644.015c0-3.63,2.875-6.622,6.07-6.622a4.417,4.417,0,0,1,4.008,2.556v-8.771h1.365a8.808,8.808,0,0,0,2.585-.232v19.4h-3.95v-2.265a4.417,4.417,0,0,1-4.008,2.556c-3.195,0-6.07-2.991-6.07-6.622m10.194,0a3.2,3.2,0,0,0-3.05-3.34,3.354,3.354,0,1,0,3.05,3.34"
          transform="translate(-1562.46 -577.557)"
          fill="#fff"
        />
        <path
          id="Path_21"
          d="M1904.937,724.073l2.585-2.091a3.65,3.65,0,0,0,3.282,1.481c2.469,0,3.514-1.1,3.514-3.427v-2.207a4.417,4.417,0,0,1-4.008,2.556c-3.195,0-6.07-2.991-6.07-6.622s2.875-6.622,6.07-6.622a4.417,4.417,0,0,1,4.008,2.556v-2.265h1.365a7.89,7.89,0,0,0,2.585-.232v12.285c0,4.589-2.817,7-7.435,7-2.614,0-4.734-.755-5.9-2.411m9.5-10.31a3.2,3.2,0,0,0-3.05-3.34,3.354,3.354,0,1,0,3.05,3.34"
          transform="translate(-1743.107 -647.304)"
          fill="#fff"
        />
        <path
          id="Path_22"
          d="M2103.3,713.791a6.83,6.83,0,0,1,6.68-6.651c3.543,0,6.36,2.9,6.36,7.261h-9.032a3.164,3.164,0,0,0,3.369,3.02,2.841,2.841,0,0,0,2.875-1.684l2.73,1.51c-.958,1.888-2.875,3.137-5.808,3.137-4.124,0-7.174-2.933-7.174-6.593m4.008-1.452h5.053a2.488,2.488,0,0,0-2.439-2.585,2.674,2.674,0,0,0-2.614,2.585"
          transform="translate(-1925.323 -647.303)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default LogoBlack;
